import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText
} from 'reactstrap';
import moment from 'moment';

class FieldMasterData extends Component {

  constructor(props) {
    super(props);
  }

  async componentDidMount() {
  }

  render() {

    return (
      <div className="animated fadeIn" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column"}}>
        <h4>Truy cập vào <a href="https://docs.google.com/spreadsheets/d/17SH6NH6H4DYQYnb8pPG84qhFbBnGRJlGSL6qMH9cG0M/edit#gid=0" target="_blank">Google Sheet Field Master Data</a> </h4>
      </div>
    );
  }
}

export default FieldMasterData;


// WEBPACK FOOTER //
// ./src/views/Dashboard/FieldMasterData.js